module.exports = __webpack_public_path__ + "static/media/018ty@3x.fd582743.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/018ty@3x.png
// module id = 1670
// module chunks = 0 1